module.exports = __webpack_public_path__ + "img/یلدا.f733d822.jpg";